import { ContentType } from '@creditsights/api-ui-web';
import { ROUTES } from '../../../Base.constants';
import { LinkGroupRoute } from '../../../components/LinkGroup/LinkGroup';
import { ContentTypeFilter, ContentTypeTag } from '../../../models';

export const FEED_SUB_HEADER_ROUTES: LinkGroupRoute[] = [
  { to: ROUTES.feed, label: 'My Feed', dataTestId: 'my-feed-link', end: true },
  { to: ROUTES.globalFeed, label: 'Global Feed', dataTestId: 'global-feed-link' },
];

export const FEED_SECTION_TITLES = {
  [ContentType.Covenants]: 'CovenantReview',
  [ContentType.News]: 'LevFinInsights',
  [ContentType.Research]: 'CreditSights',
};

export const FEED_SECTION_PAGINATION = {
  options: [100, 200],
  defaultOption: 100,
};

export const getSectionHeaderId = (contentType: ContentType): string => `articles-feed-${contentType}-header`;

export const CONTENT_TYPE_BUTTONS = [
  {
    label: 'All',
    value: ContentTypeFilter.ALL,
  },
  {
    label: 'CreditSights',
    value: ContentTypeFilter.RESEARCH,
  },
  {
    label: 'Covenant Review',
    value: ContentTypeFilter.COVENANTS,
  },
  {
    label: 'LevFin Insights',
    value: ContentTypeFilter.NEWS,
  },
];

export const contentTypeFiltersMap: Record<ContentTypeFilter, ContentTypeTag[]> = {
  [ContentTypeFilter.ALL]: [ContentTypeTag.Research, ContentTypeTag.Covenants, ContentTypeTag.News],
  [ContentTypeFilter.NEWS]: [ContentTypeTag.News],
  [ContentTypeFilter.COVENANTS]: [ContentTypeTag.Covenants],
  [ContentTypeFilter.RESEARCH]: [ContentTypeTag.Research],
};
